export default __webpack_public_path__ + "static/media/fireworks.3cd8918c.svg";